import axios from 'axios'
export default axios.create({
  baseURL: 'https://cas.polito.it/api/LATS2025/api',
  headers: {
    'Content-type': 'application/json',
  },
});